import { productsCategories } from 'constants/products';

import haircareCategoryPicture from 'assets/images/consultation/categories/haircare_category.jpg';
import skincareCategoryPicture from 'assets/images/consultation/categories/skincare_category.jpg';

const consultationCategorySelection = {
  CardProps: {
    align: 'flex-start',
  },
  name: 'consultation-category',
  route: '/consultation/category',
  shouldBeIncluded: () => true,
  public: true,
  title: 'Start your consulation',
  subtitle:
    'We’ll analyze everything from what you eat to where you live to personalize your formulas.',
  body: (
    <>
      Already gave us your email?
      <br />
      <a data-click="sign-in" data-from="category-selection" href="/signin">
        Resume here
      </a>
    </>
  ),
  options: [
    {
      dataFrom: 'category-selection',
      dataClick: productsCategories.HAIRCARE,
      value: productsCategories.HAIRCARE,
      label: 'Custom Haircare',
      description: '',
      imageUrl: haircareCategoryPicture,
      dataTestId: 'haircare-card-category',
    },
    {
      dataFrom: 'category-selection',
      dataClick: productsCategories.SKINCARE,
      value: productsCategories.SKINCARE,
      label: 'Custom Skincare',
      description: '',
      imageUrl: skincareCategoryPicture,
      dataTestId: 'skincare-card-category',
    },
  ],
  skipSave: true,
  showProgressTracker: false,
};

export default consultationCategorySelection;
